import ceo from "./img/Mehedi.png";
import cto from "./img/Jarif-Huda-Angon.png";
import cmo from "./img/asaf-kakon.jpg";

const introduction = [
  {
    id: 1,
    intro_text:
      "Bangabandhu Digital Social Innovation Award 2020 winner In addition, he is the founder of the Dinghy Foundation and EJhuli (ECommerce Platform). He is not just an entrepreneur, but also a young researcher. He has over 19 publications and is currently attempting to develop viable solutions to several epidemic diseases. He also helps out at the Asian Network of Youth Volunteers Society.",
    intro_person:
      "IEEE SPAW 2.0 Ambassador, Global Peace Chain Ambassador, GGF Cultural Ambassador, Global Governance Foundation, International Youth Society Campus Ambassador, Asia World Model United Nations Delegate.",

    name: "Mehedi Hassan",
    pic: ceo,
    designation: "Founder & CEO",
    twitter: "https://twitter.com/MehediCEO",
    facebook: "https://www.facebook.com/MhashiqCEO",
    instragram: "https://instagram.com/mh_ashiq_?igshid=YmMyMTA2M2Y=",
    linkedin: "https://www.linkedin.com/in/mh-ashiq/",
  },
  {
    id: 2,
    intro_text:
      "An entrepreneur and a young researcher. He loves to work for the youth. He is also working on the Skill developments. A large number of youth were able to develop their skills with his help, within them some was able to earn with their skills.",
    intro_person:
      "He is also founder of ecommerce platform name Choco Hub BD and Co-Founder of Dinghy Foundation. He has 3 publication and working on various research filed like AI (Artificial Intaligance), Maching Learning etc.",

    name: "Jarif Huda Angon",
    pic: cto,
    designation: "Co-Founder & CTO",
    twitter: "https://twitter.com/",
    facebook: "https://www.facebook.com/Angon.zarif",
    instragram: "https://instagram.com/angon_zarif?igshid=YmMyMTA2M2Y=",
    linkedin: "https://www.linkedin.com/in/jarif-huda-angon",
  },
  {
    id: 3,
    intro_text:
      "Young researcher from the University of Dhaka's Electrical and Electronic Engineering department serves as our CMO. He is working to address Bangladesh's unemployment issue and help young people develop their skills. He is driven to mentor new business owners who are having trouble planning and directing their enterprises. He believes that everything is doable with persistence, confidence, and hard work.",
    intro_person:
      "He wants to help the underprivileged and make people happy. He also co-founded the Dinghy Foundation (NGO). He enjoys instructing and providing consultancy services while working continually at Vcourse, an e-learning platform and subsidiary of The Virtual BD, in the field of digital marketing. He has a strong desire to learn new things and see the world.",

    name: "Asaf Ud Dulla",
    pic: cmo,
    designation: "Co-Founder & CMO",
    twitter: "https://twitter.com/",
    facebook: "https://www.facebook.com/KakonCMO",
    instragram:
      "https://www.instagram.com/invites/contact/?i=1ncexy37anvtz&utm_content=419g8qc",
    linkedin: "https://www.linkedin.com/in/asaf-ud-dulla-478908187",
  },
];

export default introduction;
